const RADIANT_DAY_TITLES_PANEL_KEY = "vocabularium_radiant_day_titles_panel";
const RADIANT_DAY_STATS_SCROLL_KEY = "vocabularium_radiant_day_stats_scroll";
const RADIANT_DAY_BLASON_PAGE_KEY = "vocabularium_radiant_day_blason_page";
const RADIANT_DAY_DISPLAYED_PORTRAIT_KEY = "vocabularium_radiant_day_displayed_portrait";
export const DISPLAYED_PORTRAIT_EVENT = "vocabularium-displayed-portrait";

export const RADIANT_DAY_PANELS = {
  TITLES: "titles",
  STATS: "stats",
};

export function readRadiantDayTitlesPanel() {
  try {
    const raw = localStorage.getItem(RADIANT_DAY_TITLES_PANEL_KEY);
    return raw === RADIANT_DAY_PANELS.STATS
      ? RADIANT_DAY_PANELS.STATS
      : RADIANT_DAY_PANELS.TITLES;
  } catch {
    return RADIANT_DAY_PANELS.TITLES;
  }
}

export function writeRadiantDayTitlesPanel(panel) {
  try {
    const value =
      panel === RADIANT_DAY_PANELS.STATS
        ? RADIANT_DAY_PANELS.STATS
        : RADIANT_DAY_PANELS.TITLES;
    localStorage.setItem(RADIANT_DAY_TITLES_PANEL_KEY, value);
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function readRadiantDayStatsScroll() {
  try {
    const value = Number(localStorage.getItem(RADIANT_DAY_STATS_SCROLL_KEY));
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
}

export function writeRadiantDayStatsScroll(scrollTop) {
  try {
    const value = Math.max(0, Math.round(Number(scrollTop) || 0));
    localStorage.setItem(RADIANT_DAY_STATS_SCROLL_KEY, String(value));
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function readRadiantDayBlasonPage(pageCount = 5) {
  if (!Number.isFinite(pageCount) || pageCount < 1) return 0;

  try {
    const value = Number(localStorage.getItem(RADIANT_DAY_BLASON_PAGE_KEY));
    return Number.isInteger(value) && value >= 0 && value < pageCount ? value : 0;
  } catch {
    return 0;
  }
}

export function writeRadiantDayBlasonPage(pageIndex) {
  try {
    const value = Number(pageIndex);
    if (!Number.isInteger(value) || value < 0) return;
    localStorage.setItem(RADIANT_DAY_BLASON_PAGE_KEY, String(value));
  } catch {
    // ignore quota / privacy mode errors
  }
}

export function readRadiantDayDisplayedPortrait(playerName = "") {
  try {
    const parsed = JSON.parse(localStorage.getItem(RADIANT_DAY_DISPLAYED_PORTRAIT_KEY) || "null");
    const index = Number(parsed?.blasonIndex);
    const gradeLabel = typeof parsed?.gradeLabel === "string" ? parsed.gradeLabel.trim() : "";
    const cachedName = typeof parsed?.playerName === "string" ? parsed.playerName : "";
    const currentName = String(playerName || "").trim();
    if (currentName && cachedName && cachedName !== currentName) return null;
    if (!Number.isInteger(index) || index < 0 || !gradeLabel) return null;
    return { blasonIndex: index, gradeLabel };
  } catch {
    return null;
  }
}

export function writeRadiantDayDisplayedPortrait({ playerName = "", blasonIndex, gradeLabel } = {}) {
  try {
    const index = Number(blasonIndex);
    const label = typeof gradeLabel === "string" ? gradeLabel.trim() : "";
    if (!Number.isInteger(index) || index < 0 || !label) return;
    localStorage.setItem(
      RADIANT_DAY_DISPLAYED_PORTRAIT_KEY,
      JSON.stringify({
        playerName: String(playerName || "").trim(),
        blasonIndex: index,
        gradeLabel: label,
      })
    );
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent(DISPLAYED_PORTRAIT_EVENT, { detail: { blasonIndex: index } })
      );
    }
  } catch {
    // ignore quota / privacy mode errors
  }
}
